import { cn } from '@localagent/ui/lib/utils';
import { usePlatform } from '@localagent/platform';
import { ThemeToggle } from '../ThemeToggle';
import { BridgeConnectionIndicator } from '../shogunchop/BridgeConnectionIndicator';
import { IndexingProgressIndicator } from '../search/IndexingProgressIndicator';
import { useIndexingProgressStream } from '../../hooks/useIndexingProgressStream';
import { DownloadForMac } from '../DownloadForMac';
import { WebDesktopHandoff } from '../../lifecycle/WebDesktopHandoff';
import { MacTrafficLightSlot } from './MacTrafficLightSlot';
import logoLightUrl from '../../assets/logo-horizontal-light.svg';
import logoDarkUrl from '../../assets/logo-horizontal-dark.svg';

export function TitleBarWordmark() {
  return (
    <div className="flex items-center" data-testid="titlebar-wordmark">
      <h1 className="sr-only">ShogunChop</h1>
      <img
        src={logoLightUrl}
        alt=""
        aria-hidden="true"
        data-testid="titlebar-logo-light"
        className="h-5 w-auto dark:hidden"
      />
      <img
        src={logoDarkUrl}
        alt=""
        aria-hidden="true"
        data-testid="titlebar-logo-dark"
        className="hidden h-5 w-auto dark:block"
      />
    </div>
  );
}

export function TitleBarStatusCluster() {
  return (
    <div
      role="status"
      aria-label="System status"
      data-testid="titlebar-status-cluster"
      className="flex items-center gap-2 rounded-md px-2 py-1"
    >
      <BridgeConnectionIndicator />
      <IndexingProgressIndicator />
    </div>
  );
}

export function TitleBar() {
  useIndexingProgressStream();
  const platform = usePlatform();
  const isMac = platform.osPlatform === 'darwin';
  const isDesktop = platform.type === 'desktop';

  return (
    <div
      data-testid="app-titlebar"
      className="flex h-12 items-stretch border-b bg-background"
    >
      {isMac && <MacTrafficLightSlot />}
      <div
        className={cn(
          'flex min-w-0 flex-1 items-center justify-between px-4',
          isDesktop && 'titlebar',
        )}
      >
                <div className="flex items-center gap-3">
                  <TitleBarWordmark />
                </div>

        <div className="flex items-center gap-2">
          {isDesktop ? <DownloadForMac compact /> : <WebDesktopHandoff />}
          <TitleBarStatusCluster />
          <ThemeToggle />
        </div>

        {isDesktop && !isMac && (
          <div className="flex items-center gap-1">
            <button
              className="flex h-8 w-8 items-center justify-center hover:bg-accent"
              aria-label="Minimize"
            >
              <span className="text-title-2">−</span>
            </button>
            <button
              className="flex h-8 w-8 items-center justify-center hover:bg-accent"
              aria-label="Maximize"
            >
              <span className="text-title-2">□</span>
            </button>
            <button
              className="flex h-8 w-8 items-center justify-center hover:bg-destructive hover:text-destructive-foreground"
              aria-label="Close"
            >
              <span className="text-title-2">×</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
